import MessagePropertiesProvider from './MessagePropertiesProvider';

const data = {
  __init__: [ 'messagePropertiesProvider' ],
  messagePropertiesProvider: [ 'type', MessagePropertiesProvider ]
};

export default data;